<template>
  <section class="healthcare-carousel" :class="{'container': shouldHaveContainerLayout}">
    <vueper-slides
        ref="healthcareTopRef"
        class="top-gallery"
        :slide-ratio="1 / 4"
        :bullets="false"
        :arrows="false"
        :dragging-distance="50"
        @slide="$refs.healthcareBottomRef && $refs.healthcareBottomRef.goToSlide($event.currentSlide.index, { emit: false })"
    >
      <vueper-slide
          v-for="slide in healthcare.topGallery"
          :key="slide.id"
          :title="slide.title"
          class="position-relative"
      >
        <template #content>
          <img
              :src="slide.img.link"
              class="w-100 mw-100 mh-100 h-100 fit-cover"
              :alt="slide.img.alt"
              width="500"
              height="480"
          />
          <div class="content position-absolute d-flex justify-content-center w-100">
            <div class="content-wrapper px-3 px-lg-0">
              <p class="h2">{{ slide.title }}</p>
              <div class="d-flex flex-column flex-lg-row justify-content-center desc">
                <div class="desc-p">
                  <p>{{ slide.description }}</p>
                </div>
                <div class="desc-btn" v-if="slide.isButtonShown">
                  <ButtonRed hyperlink :href="slide.button.link" :text="slide.button.text" class="w-100" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
    <vueper-slides
        ref="healthcareBottomRef"
        class="thumb-gallery"
        :class="{'thumb-gallery-less6': healthcare.thumbsGallery.length < 6}"
        :gap="2"
        :slide-ratio="1 / 8"
        :dragging-distance="10"
        :visible-slides="6"
        :arrows="true"
        :bullets="false"
        :breakpoints="breakpoints"
        @slide="$refs.healthcareTopRef && $refs.healthcareTopRef.goToSlide($event.currentSlide.index, { emit: false })"

    >
      <vueper-slide
          v-for="(thumb, index) in healthcare.thumbsGallery"
          :key="thumb.id"
          @click.native="$refs.healthcareBottomRef.goToSlide(index )">
          >
        <template #content>
          <article class="d-flex flex-column article">
            <img
                :src="thumb.img.link"
                class="w-100 mw-100 fit-cover"
                :alt="thumb.img.alt"
                draggable="false"
                width="190"
                height="80"
            />
            <div class="d-flex align-items-center justify-content-center article-body" ref="articleBodyRef">
              <p>{{thumb.title}}</p>
            </div>
          </article>
        </template>
      </vueper-slide>
    </vueper-slides>
  </section>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'

import ButtonRed from "@/components/common/ButtonRed";
import {handleListeners} from "@/utils/utils";

export default {
  name: 'MyComponent',
  components: { VueperSlides, VueperSlide, ButtonRed },
  methods: {
    setWrapperHeight() {
      //@ready="setWrapperHeight"
      const slideImgHeight = 85;
      const wrapper = this.$refs.healthcareBottomRef.$el.querySelector('.vueperslides__parallax-wrapper')
      const maxHeight = Math.max(...this.$refs.articleBodyRef.map(elem => elem.offsetHeight)) + slideImgHeight + 10;

      setTimeout(() => {
        // bad decision, but no other ways
        // carousel does not support adaptive height based on content
        wrapper.style.height = `${maxHeight}px`
      }, 10)
    },
    handleTheLastSlide(slide){
      const slidesArray = this.$refs.healthcareBottomRef.$el.querySelectorAll('.vueperslide');

      // -5 Because carousel author made a mistake so first slide has "1" index instead of -1 or 0
      // Therefore we subtract slide with wrong index and slide with zero index
      // And in stock we add 3 slides that user can not see the last slide on incorrect position
      //  @next="handleTheLastSlide($event)"
      const amount = slidesArray.length - 5
      const theLastIndex = slidesArray.length - 1

      if(slide.currentSlide.index === amount) {
        this.$refs.healthcareBottomRef.$el.querySelector('.vueperslides__inner').style.paddingRight = '65px'
      }

      if(slide.currentSlide.index === theLastIndex) {
        this.$refs.healthcareBottomRef.$el.querySelector('.vueperslides__inner').style.paddingRight = '0'
      }
    },
    handleScreenWidth(){
      this.shouldHaveContainerLayout = !window.matchMedia('(max-width: 992px)').matches
    },
  },
  data() {
    return {
      breakpoints: {
        768: {
          visibleSlides: 2
        },
        992: {
          visibleSlides: 3
        },
      },
      shouldHaveContainerLayout: true
    }
  },
  mounted(){
    handleListeners(['resize', 'DOMContentLoaded'], this.handleScreenWidth)
  },
  unmounted() {
    handleListeners(['resize', 'DOMContentLoaded'], this.handleScreenWidth, true)
  },
  props: {
    healthcare: {
      topGallery: Array,
      thumbsGallery: Array
    }
  }
}
</script>

